import { combineReducers } from "@reduxjs/toolkit";
import user from "./reducers/authentication/authentication";
import userList from "./reducers/authentication/authenticationList";
import userPublic from "./reducers/authentication/authenticationPublic";
import addReview from "./reducers/courses/addReview";
import allReviews from "./reducers/courses/AllReviews";
import contentBlocks from "./reducers/courses/contentBlocks";
import courseDetails from "./reducers/courses/courseDetails";
import courseEnroll from "./reducers/courses/courseEnroll";
import courseEnrollmentList from "./reducers/courses/courseEnrollmentList";
import courseNumberOfEnrollments from "./reducers/courses/courseNumberOfEnrollments";
import courseOutline from "./reducers/courses/courseOutline";
import courseProgress from "./reducers/courses/courseProgress";
import courseReview from "./reducers/courses/courseReview";
import courses from "./reducers/courses/courses";
import downloadReq from "./reducers/courses/downloadReq";
import homeData from "./reducers/home/homeData";
import organizations from "./reducers/home/organizations";

const rootReducer = combineReducers({
    user,
    userPublic,
    userList,
    courses,
    courseDetails,
    courseReview,
    allReviews,
    downloadReq,
    courseProgress,
    courseOutline,
    courseEnroll,
    addReview,
    contentBlocks,
    courseEnrollmentList,
    courseNumberOfEnrollments,
    homeData,
    organizations
});

export default rootReducer;
